import React from "react" ;
import AppBodyNotificationDropdown from "root/Wieldy/ApplicationModules/Common/Body/AppBodyNotificationDropdown";
import {
    MessageFilters,
    MessageMenuTitles,
    SafeguardingFilters,
    SafeguardingMenuTitles
} from "root/DataFunctions/Constants";
import {useLocation} from "react-router-dom";
import queryString from "query-string";

const SafeguardingAppBodyHeader= (props) =>
{
    const {pathname}  = useLocation();

    const displayHeader = () =>
    {
        if(pathname.includes(SafeguardingFilters.MISUSE))
        {
            return <h4 className="title">{SafeguardingMenuTitles.MISUSE}</h4>
        }
        else if (pathname.includes(SafeguardingFilters.BLOCKED_USERS))
        {
            return <h4 className="title">{SafeguardingMenuTitles.BLOCKED_USERS}</h4>
        }
        else{
            return <h4 className="title">{SafeguardingMenuTitles.MISUSE}</h4>
        }
    }

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div className="child-menu-item">
                {displayHeader()}
            </div>

            {/*<AppBodyNotificationDropdown />*/}

        </div>
    ) ;
}

export default SafeguardingAppBodyHeader;
